/** Elevate alone sets the assignment; no randomization, cookies or URL overrides. */
const TEST_ID = 'MC_CART_MAISONCART_KLEONE';
const ASSIGNMENT_ATTRIBUTE = 'data-maison-cart-variant';

class MaisonCartTest extends HTMLElement {
  #observer;
  #loading;
  #waitingForClose;

  connectedCallback() {
    this.#observer?.disconnect();
    this.#observer = new MutationObserver(() => this.#activate());
    this.#observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [ASSIGNMENT_ATTRIBUTE],
    });
    this.#activate();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#waitingForClose?.abort();
  }

  async #activate() {
    if (document.documentElement.getAttribute(ASSIGNMENT_ATTRIBUTE) !== TEST_ID ||
        this.querySelector(':scope > cart-drawer-component') || this.#loading || !this.isConnected) return;

    const control = this.parentElement?.querySelector(':scope > cart-drawer-component');
    const template = this.querySelector('template[data-maison-cart-template]');
    if (control?.localName !== 'cart-drawer-component' || !template) return;

    // A late assignment must not dismiss a cart the shopper is already using.
    if (control.querySelector('dialog[open]')) {
      this.#waitingForClose?.abort();
      this.#waitingForClose = new AbortController();
      control.addEventListener('dialog:close', () => this.#activate(), {
        once: true, signal: this.#waitingForClose.signal,
      });
      return;
    }

    this.#loading = true;
    try {
      await import(this.dataset.cartScript);
      await customElements.whenDefined('cart-drawer-component');
      if (!this.isConnected || document.documentElement.getAttribute(ASSIGNMENT_ATTRIBUTE) !== TEST_ID) return;
      if (control.querySelector('dialog[open]')) return;

      const fragment = document.importNode(template.content, true);
      const drawer = fragment.querySelector('cart-drawer-component');
      if (!drawer?.querySelector('kleone-cart')) return;

      // Park Control in an inert template. Its custom elements disconnect, so
      // document.querySelector and native/app cart events have exactly one owner.
      const parked = document.createElement('template');
      parked.dataset.maisonCartControl = '';
      control.replaceWith(parked);
      parked.content.append(control);
      this.append(fragment);
      this.setAttribute('data-maison-cart-active', '');
    } catch (error) {
      // A failed module load leaves the original cart fully operational.
      console.error('Maison cart experiment could not initialize', error);
    } finally {
      this.#loading = false;
      // If the drawer opened during loading, retry only after it closes.
      if (this.isConnected && control.querySelector('dialog[open]')) this.#activate();
    }
  }
}

if (!customElements.get('maison-cart-test')) {
  customElements.define('maison-cart-test', MaisonCartTest);
}
